import { render, staticRenderFns } from "./CreationCentre.vue?vue&type=template&id=6b9026d1&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./CreationCentre.vue?vue&type=script&lang=js&"
export * from "./CreationCentre.vue?vue&type=script&lang=js&"
import style0 from "./CreationCentre.vue?vue&type=style&index=0&id=6b9026d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9026d1",
  null
  
)

export default component.exports